export enum CompleteActivityDismantledSeriesOrder {

    dismantledImages,
    confirmAnalyzedData,
    serialAndPartNumbers,
    generalDismantledProperties
}